import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/api.service';
import { AddNumberDialogComponent } from '../add-number-dialog/add-number-dialog.component';
import { ConformationComponent } from '../conformation/conformation.component';
import { CreateCompanyDialogComponent } from '../create-company-dialog/create-company-dialog.component';



@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompanyComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] =['name', 'country', 'country_code', 'branch_code', 'id', 'updated_at', 'created_at'];;
  dataSource :any;
  showSpinner = false;
  blankCompanyData = {name:'',country:'',country_code:'', branch_code:'',id:'',numbers:[]};
  searchText;
  filteredCompanyList = [];
  companyList = [];
  animal: string;
  name: string;
  screenwidth =null;
  dialogwidth = null;

  constructor(
    private dialog: MatDialog,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
    ) {
    
  }

  ngOnInit(): void {
    this.screenwidth = screen.width;
    if(this.screenwidth < 500){
      this.dialogwidth = '90%';
    }else{
      this.dialogwidth = '50%';
    }
    this.refreshCompanyList();
  }

  refreshCompanyList(){
    this.showSpinner = true;
    this._apiService.getCompanyList().subscribe(res => {
      if (res) {
        this.companyList = res;
        this.filteredCompanyList = res;
        this.dataSource = new MatTableDataSource<companyData>(res);
        setTimeout(() => this.dataSource.paginator = this.paginator);
        this.showSpinner = false;
        console.log(this.companyList);
      }
    },
    (error)=>{
      this.showSpinner = false;
    });
  }

  openDialog(companyInfo): void {
    const dialogRef = this.dialog.open(CreateCompanyDialogComponent, {
      width: this.dialogwidth,
      data: {companyData: companyInfo}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.refreshCompanyList();
    });
  }

  openAddNumberDialog(companyInfo): void {
    const dialogRef = this.dialog.open(AddNumberDialogComponent, {
      width: this.dialogwidth,
      data: {companyData: companyInfo}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.refreshCompanyList();
    });
  }

  deleteCompany(data){
    const dialogRef = this.dialog.open(ConformationComponent, {
      width: '20rem',
      data: {id: data.id,type:'Company'}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.refreshCompanyList();
    });
    
  
  }

  onSearch(e){
    if(e == null){
      this.filteredCompanyList = this.companyList;
      this.dataSource = new MatTableDataSource<companyData>(this.companyList);
      setTimeout(() => this.dataSource.paginator = this.paginator);
    }
    this.filteredCompanyList = this.companyList.filter(ele => ele.name.toLowerCase().includes(e.toLowerCase()));
    this.dataSource = new MatTableDataSource<companyData>(this.filteredCompanyList);
    setTimeout(() => this.dataSource.paginator = this.paginator);
  }
}

export interface companyData {
  id: number;
  name: string;
  country: string;
  numbers:[];
  country_code: string;
  branch_code: string;
  created_at:string;
  updated_at:string;
};
